import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { useAction } from './react-redux'

export const useDataLoader = (action, selector) => {
  const data = useSelector(selector)
  const execAction = useAction(action)

  useEffect(() => {
    execAction()
  }, [execAction])

  return data
}
